import script from "./PresenterView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PresenterView.vue?vue&type=script&lang=ts&setup=true"

import "./PresenterView.vue?vue&type=style&index=0&id=f770d810&lang=scss&scoped=true"

import exportComponent from "C:\\work\\to-create\\bailing\\yc-bailing-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f770d810"]])

export default __exports__